import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import { usePlaceLevelEditAction, usePlaceLevelRemoveAction, usePlaceLevelsRemoveAction } from './actions'

const useSingleActions = (item, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []

  const edit = usePlaceLevelEditAction(item)
  const remove = usePlaceLevelRemoveAction(item)

  return [
    ...appendIf(edit.hasPermission, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: edit.click
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      icon: 'BsTrash',
      color: COLORS.lightRed,
      onClick: remove.click
    })
  ]
}

const useMultiActions = (items, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []

  const remove = usePlaceLevelsRemoveAction(items)

  return [
    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      color: COLORS.lightRed,
      icon: 'BsTrash',
      onClick: remove.click
    })
  ]
}

export const usePlaceLevelsActionsList = (item, ids, opts = {}) => {
  const singleOptions = useSingleActions(item, opts)
  const multiOptions = useMultiActions(ids, opts)

  if (!!ids && ids.length > 1) return multiOptions
  if (!!item) return singleOptions

  return multiOptions
}
